var render = function render(_c,_vm){return _c('div',_vm._g({key:"placeholder",class:{
        [_vm.$style.root]: true,
        'cursor-pointer': _vm.listeners.click != null
    },attrs:{"title":`${_vm.parent.type} placeholder`}},{
        ...(_vm.listeners.click && {
            click: () => _vm.listeners.click(_vm.$event)
        })
    }),[_c('mark',{class:_vm.$style.mark},[_vm._v(" "+_vm._s((_vm.data.attrs && _vm.data.attrs.title))+" ")]),_c('code',{class:_vm.$style.code},[(_vm.scopedSlots.default != null)?_c('div',[_vm._t("default")],2):_vm._e(),(_vm.scopedSlots.custom != null)?_c('div',{key:"slot",class:{
                [_vm.$style.slot]: true
            },attrs:{"title":"slot area"}},[_vm._t("custom")],2):(_vm.props.slotNames.length > 0)?_vm._l((_vm.props.slotNames),function(slotName){return (_vm.scopedSlots[`slot-${slotName}`] != null)?_c('div',{key:slotName,class:{
                    [_vm.$style.slot]: true,
                    [_vm.$style['slot--active']]: _vm.injections.hasSlotContent({ parent: _vm.parent, slotName })
                },attrs:{"title":"slot area","data-slot":slotName}},[_vm._t(`slot-${slotName}`,function(){return [_vm._v(_vm._s(`${slotName} slot content`))]})],2):_vm._e()}):[_vm._v("Slot content")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }